import axiosInstance from "../../constants/axiosConfig";
let setGlobalLoader;

const initializeLoader = (setLoaderCallback) => {
  setGlobalLoader = setLoaderCallback;
};

const toggleLoader = (isVisible) => {
  if (setGlobalLoader) {
    setGlobalLoader(isVisible);
  }
};

const Get = async (endpoints) => {
  try {
    toggleLoader(true); // Show loader
    const response = await axiosInstance.get(endpoints);
    toggleLoader(false); // Hide loader
    return response;
  } catch (error) {
    toggleLoader(false); // Hide loader
    return error;
  }
};

const Post = async (endpoints, data, customHeaders = {}) => {
  try {
      toggleLoader(true); // Show loader
      const response = await axiosInstance.post(endpoints, data, {
          headers: {
              ...customHeaders,
          },
      });
      toggleLoader(false)
      return response;
  } catch (error) {
      toggleLoader(false)
      return error;
  }
}

const Put = async (endpoint, data) => {
  try {
    toggleLoader(true); // Show loader
    const response = await axiosInstance.put(endpoint, data);
    toggleLoader(false); // Hide loader
    return response;
  } catch (error) {
    toggleLoader(false); // Hide loader
    throw error; // Propagate error
  }
};

const Delete = async (endpoint) => {
  try {
    toggleLoader(true); // Show loader
    const response = await axiosInstance.delete(endpoint);
    toggleLoader(false); // Hide loader
    return response;
  } catch (error) {
    toggleLoader(false); // Hide loader
    throw error; // Propagate error
  }
};


function generateSlug(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/[\s\W-]+/g, "-") // replaces spaces and non-word chars with hyphen
    .replace(/^-+|-+$/g, ""); // trims hyphens from start/end
}


export { Get, Post, Put, Delete, initializeLoader, generateSlug };
